import { apiGet } from '../../api'

export const delete_facilitator = facilitator_id => {
  return apiGet({
    endpoint: `user/delete_user?user_id=${facilitator_id}`
  })
}
